// src/services/prepCcpService.js
// Cook+cool CCP production flow for intermediate products — see docs/PREP_CCP_MODULE.md.

import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

// ── Config (per intermediate product) ──────────────────────────────────────
const getConfig = async (productId) => {
  const res = await axios.get(`${API_URL}/api/prep-ccp/config/${productId}`, { headers: authHeaders() });
  return res.data.config;
};

const saveConfig = async (productId, data) => {
  const res = await axios.put(`${API_URL}/api/prep-ccp/config/${productId}`, data, { headers: authHeaders() });
  return res.data.config;
};

// ── Runs ────────────────────────────────────────────────────────────────────
const getRuns = async (status = 'COMPLETED') => {
  const res = await axios.get(`${API_URL}/api/prep-ccp/runs`, { headers: authHeaders(), params: { status } });
  return res.data.runs;
};

const getActiveRuns = async () => {
  const res = await axios.get(`${API_URL}/api/prep-ccp/runs/active`, { headers: authHeaders() });
  return res.data.runs;
};

const getRun = async (id) => {
  const res = await axios.get(`${API_URL}/api/prep-ccp/runs/${id}`, { headers: authHeaders() });
  return res.data;
};

const startRun = async (data) => {
  const res = await axios.post(`${API_URL}/api/prep-ccp/runs/start`, data, { headers: authHeaders() });
  return res.data.run;
};

const recordTemp = async (runId, data) => {
  const res = await axios.post(`${API_URL}/api/prep-ccp/runs/${runId}/temps`, data, { headers: authHeaders() });
  return res.data.tempReading;
};

const pauseCook = async (runId) => {
  const res = await axios.post(`${API_URL}/api/prep-ccp/runs/${runId}/pause-cook`, {}, { headers: authHeaders() });
  return res.data;
};

const resumeCook = async (runId) => {
  const res = await axios.post(`${API_URL}/api/prep-ccp/runs/${runId}/resume-cook`, {}, { headers: authHeaders() });
  return res.data;
};

const stopCook = async (runId, data) => {
  const res = await axios.post(`${API_URL}/api/prep-ccp/runs/${runId}/stop-cook`, data, { headers: authHeaders() });
  return res.data;
};

const endCoolStage1 = async (runId, data) => {
  const res = await axios.post(`${API_URL}/api/prep-ccp/runs/${runId}/end-cool-stage1`, data, { headers: authHeaders() });
  return res.data;
};

const endCoolStage2 = async (runId, data) => {
  const res = await axios.post(`${API_URL}/api/prep-ccp/runs/${runId}/end-cool-stage2`, data, { headers: authHeaders() });
  return res.data;
};

const completeRun = async (runId, data) => {
  const res = await axios.post(`${API_URL}/api/prep-ccp/runs/${runId}/complete`, data, { headers: authHeaders() });
  return res.data.run;
};

const verifyAndLog = async (runId, data) => {
  const res = await axios.post(`${API_URL}/api/prep-ccp/runs/${runId}/verify-and-log`, data, { headers: authHeaders() });
  return res.data;
};

const prepCcpService = {
  getConfig, saveConfig,
  getRuns, getActiveRuns, getRun, startRun,
  recordTemp, pauseCook, resumeCook, stopCook, endCoolStage1, endCoolStage2, completeRun, verifyAndLog,
};

export default prepCcpService;
